(() => {
  const root = document.getElementById('AbastikDeliveryGate');
  if (!root) return;

  const state = {
    trigger: null,
    form: null,
    href: '',
    bypassSubmit: false,
    busy: false,
  };

  function openGate(trigger) {
    state.trigger = trigger || null;
    state.form = trigger?.form || null;
    state.href = trigger?.href || '';
    root.hidden = false;
    document.body.classList.add('abastik-delivery-gate-open');
    root.querySelector('[data-abastik-method="delivery"]')?.focus();
  }

  function closeGate() {
    root.hidden = true;
    document.body.classList.remove('abastik-delivery-gate-open');
    state.trigger?.focus?.();
  }

  async function saveChoice(method) {
    const value = method === 'pickup' ? 'Retiro en tienda' : 'Envío a domicilio';
    try {
      sessionStorage.setItem('abastik_delivery_method', value);
    } catch (_) {}

    try {
      await fetch('/cart/update.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
        body: JSON.stringify({
          attributes: {
            'Método de entrega ABASTIK': value,
          },
        }),
      });
    } catch (error) {
      console.warn('[ABASTIK] No se pudo guardar la preferencia de entrega en el carrito.', error);
    }
  }

  function proceedToCheckout() {
    state.bypassSubmit = true;
    closeGate();

    if (state.form && state.trigger && typeof state.form.requestSubmit === 'function') {
      state.form.requestSubmit(state.trigger);
      setTimeout(() => { state.bypassSubmit = false; }, 1500);
      return;
    }

    if (state.href) {
      window.location.assign(state.href);
      return;
    }

    window.location.assign('/checkout');
  }

  async function chooseMethod(method, button) {
    if (state.busy) return;
    state.busy = true;
    const original = button?.innerHTML;
    if (button) {
      button.disabled = true;
      button.setAttribute('aria-busy', 'true');
    }

    await saveChoice(method);
    proceedToCheckout();

    setTimeout(() => {
      state.busy = false;
      if (button) {
        button.disabled = false;
        button.removeAttribute('aria-busy');
        if (original) button.innerHTML = original;
      }
    }, 1800);
  }

  document.addEventListener('click', (event) => {
    if (state.bypassSubmit) return;

    const checkoutButton = event.target.closest('button[name="checkout"], input[name="checkout"], a[href^="/checkout"], a[href*="/checkout?"]');
    if (!checkoutButton || checkoutButton.closest('#AbastikDeliveryGate')) return;

    event.preventDefault();
    event.stopPropagation();
    openGate(checkoutButton);
  }, true);

  document.addEventListener('submit', (event) => {
    if (state.bypassSubmit) return;
    const submitter = event.submitter;
    const isCheckout = submitter?.name === 'checkout' || submitter?.id === 'checkout';
    if (!isCheckout) return;

    event.preventDefault();
    event.stopPropagation();
    openGate(submitter);
  }, true);

  root.addEventListener('click', (event) => {
    if (event.target.closest('[data-abastik-close]')) {
      closeGate();
      return;
    }

    const button = event.target.closest('[data-abastik-method]');
    if (!button) return;
    chooseMethod(button.dataset.abastikMethod, button);
  });

  document.addEventListener('keydown', (event) => {
    if (event.key === 'Escape' && !root.hidden) closeGate();
  });
})();
